/**
 * This module provides functions to create FetchRequest objects for the portfolio statistics API endpoint.
 * @module
 */

import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type { FetchRequest, UUID } from "../base/ui_general/GeneralInterfaces";

/**
 * Creates a FetchRequest object for querying portfolio statistics for a given transaction.
 * @param transaction_id The UUID of the transaction to query portfolio statistics for.
 * @returns A FetchRequest object for the portfolio statistics endpoint.
 */
export function getRequest_get_portfolio_statistics(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.PORTFOLIO_STATISTICS,
        method: HttpMethods.GET,
        query_parameters: { transaction_id: transaction_id },
    };
}
